import type * as monaco from "monaco-editor";

export function convertDiffToMonaco(
  diff: string,
  contextStartLine: number,
  contextCode: string,
): monaco.editor.IIdentifiedSingleEditOperation[] {
  if (!diff.startsWith("```")) {
    return [];
  }

  const lines = diff.split("\n");
  const diffLines = lines.slice(1, lines.length - 1);

  const contextCodeLines = contextCode.split("\n");

  const firstDiffLine = diffLines[0];

  let replaceStartLine = 0;
  for (let i = 0; i < contextCodeLines.length; i++) {
    if (contextCodeLines[i] === firstDiffLine) {
      replaceStartLine = i;
      break;
    }
  }

  let replaceEndLine = contextCodeLines.length - 1;
  const lastDiffLine = diffLines[diffLines.length - 1];
  for (let i = contextCodeLines.length - 1; i >= 0; i--) {
    if (contextCodeLines[i] === lastDiffLine) {
      replaceEndLine = i;
      break;
    }
  }

  const monacoChanges: monaco.editor.IIdentifiedSingleEditOperation[] = [
    {
      range: {
        startLineNumber: contextStartLine + replaceStartLine + 1,
        startColumn: 1,
        endLineNumber: contextStartLine + replaceEndLine + 1,
        endColumn: 999999999,
      },
      text: diffLines.join("\n"),
    },
  ];

  return monacoChanges;
}
